<template>
  <div id="app">
    <StoreHeader v-if="showAccountNavbar" />
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> | 
      <router-link to="/login">Login</router-link>
    </nav> -->
    <router-view/>
  </div>
</template>

<script>
import StoreHeader from '@/components/store/StoreHeader.vue';

export default {
  name: 'App',
  components: { StoreHeader },
  computed: {
    showAccountNavbar() {
      return ['cliente-login', 'cliente-registro', 'cliente-perfil', 'google-callback', 'pedidos', 'carrito', 'Checkout', 'RecuperarPassword', 'ResetPassword', 'blog', 'blog-article'].includes(this.$route.name);
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.v-btn:not(.v-btn--icon) {
  border-radius: var(--site-button-radius, 8px) !important;
}

html[data-card-style="flat"] .v-card {
  border-color: transparent !important;
  box-shadow: none !important;
}

html[data-card-style="bordered"] .v-card {
  border: 1px solid #e2e8f0 !important;
  box-shadow: none !important;
}

#app > .auth-page {
  min-height: calc(100vh - 44px) !important;
  padding-top: 48px !important;
}

#app > .auth-page .back {
  top: 14px !important;
}

#app > .pedidos-page {
  padding-top: 60px !important;
}

.checkout-empty { min-height: 340px; padding: 30px; display:flex; flex-direction:column; align-items:center; justify-content:center; text-align:center; border:1px solid #dedede; border-radius:14px; background:#f5f5f5; }
.checkout-empty__icon { width:78px; height:78px; display:grid; place-items:center; border-radius:50%; background:#e4e4e4; }
.checkout-empty h2 { margin:16px 0 6px; color:#111; font-size:1.3rem; }
.checkout-empty p { max-width:480px; margin:0 0 20px; color:#666; }

@media (min-width: 960px) {
  #app > .fondo-pagina { max-width:1120px !important; padding-top:58px !important; padding-bottom:18px !important; }
  #app > .fondo-pagina .contenedor-principal { padding:22px 28px !important; }
  #app > .fondo-pagina .contenedor-principal > h1 { margin-bottom:18px !important; }
  #app > .fondo-pagina .tabla-productos { margin-bottom:14px !important; }
  #app > .fondo-pagina .seccion-checkout { margin-bottom:14px !important; }
  #app > .fondo-pagina .titulo-seccion { padding:12px 16px !important; }
  #app > .fondo-pagina .contenido-seccion { padding:15px 18px !important; }
}

@media (min-width: 781px) {
  .auth-page { padding: 44px 22px 18px !important; }
  .auth-page .back { top: 15px !important; }
  .auth-page .auth-shell { width: min(100%, 980px) !important; min-height: 535px !important; }
  .auth-page .intro { padding: 44px !important; }
  .auth-page .intro h1 { font-size: 3.2rem !important; }
  .auth-page .benefits { margin-top: 28px !important; }
  .auth-page .auth-card { padding: 34px 52px !important; }
  .auth-page .auth-card header { margin-bottom: 18px !important; }
  .auth-page .auth-card h2 { font-size: 1.85rem !important; }
  .auth-page .main-btn, .auth-page .google-btn { height: 43px !important; }
  .auth-page .divider { margin: 16px 0 !important; }
  .auth-page .register { margin-top: 16px !important; padding-top: 14px !important; }
}

@media (max-width: 780px) {
  .auth-page { padding: 42px 10px 10px !important; align-items: start !important; }
  .auth-page .back { top: 12px !important; left: 14px !important; }
  .auth-page .auth-shell { grid-template-columns: 1fr !important; min-height: 0 !important; border-radius: 14px !important; }
  .auth-page .intro { display: none !important; }
  .auth-page .auth-card { padding: 22px 18px !important; }
  .auth-page .auth-card header { margin-bottom: 14px !important; }
  .auth-page .auth-card h2 { font-size: 1.55rem !important; }
  .auth-page .main-btn, .auth-page .google-btn { height: 42px !important; }
  .auth-page .divider { margin: 12px 0 !important; }
  .auth-page .register { margin-top: 11px !important; padding-top: 11px !important; }
  .checkout-empty { min-height:300px; padding:22px 15px; }
}
</style>
